// extracted by mini-css-extract-plugin
export default {"base":"Dashboard_base__1S2DR","mainPanel":"Dashboard_mainPanel__YlCeR"};